import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Contact, {
  isVisible: () => true,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Contact,
    title: 'Contact',
    url: '/app/crm/contact',
    iconclass: 'far fa-phone-volume',
    target: '_top',
  }),
});
